import { JsonObject } from 'json2typescript';
import { ChatTopicsAddRequestInterface } from '../interfaces/chat-topics-add-request.interface';

@JsonObject('ChatTopicsAddRequestModel')
export class ChatTopicsAddRequestModel
  implements ChatTopicsAddRequestInterface
{
  Subject: string;
  ChatCategoryId: string;
  Color: string;
}
